/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ConfigureAdminRolesModal_UserFragmentDoc } from './ConfigureAdminRolesModal.graphql';
export type AdminProfilesTable_UserFragment = { __typename: 'User', createdAt: any, lastLogin?: any | null, id: string, givenName: string, familyName: string, email: string, roles: Array<Types.Role>, serviceAdminRoles: Array<Types.ServiceAdminRole>, customerIds?: Array<string> | null };

export const AdminProfilesTable_UserFragmentDoc = gql`
    fragment AdminProfilesTable_user on User {
  ...ConfigureAdminRolesModal_user
  createdAt
  lastLogin
}
    ${ConfigureAdminRolesModal_UserFragmentDoc}`;